import { DecoderHelpers } from '@headless-workspace/utils';
import { z } from 'zod';
import { ImageDTO } from '../../../../../client';

export const BrandCornerBannerDTO = z.object({
    type: DecoderHelpers.caseInsensitiveLiteral('brand'),
    title: z.string(),
    description: z.string(),
    image: ImageDTO,
    cta: z.object({
        label: z.string(),
        link: z.string(),
    }),
});

export type BrandCornerBannerDTO = z.infer<typeof BrandCornerBannerDTO>;
